import { Close } from "@mui/icons-material";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Avatar,
  Card,
  CardContent,
  CardMedia,
  DialogContent,
  Divider,
  IconButton,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import moment from "moment";
import React, { useEffect, useState } from "react";
import OTPInput from "react-otp-input";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Rating from "@mui/material/Rating";
import noImageTwo from "../../assets/images/FrankIcons/noImageAvailable.png";

import {
  ExpandedIcon,
  HomeIcon,
  HoverStar,
  PointerIcon,
  StarIcon,
  StarIconGray,
  VerifyIcon,
} from "../../assets/images/FrankIcons";

import noImageFile from "../../assets/images/FrankIcons/noImageAvailable.png";
import apiServices from "../../services/RequestHandler";
import { RootState } from "../../Store";
import { strings } from "../../Store/Localization";
import CustomButton from "../../UiComponent/CustomButton";
import DraggableDialog from "../../UiComponent/DraggableDialog";
import Loader from "../../UiComponent/Loader";
import Toast from "../../UiComponent/Toast/Toast";
import {
  color_theme,
  defaultLabelColors,
  getStatusColors,
  no_profile_image,
  status_translations,
} from "../../utils/constants";
import { decrypt } from "../../utils/Encrypt";
import FrankConstants from "../../utils/FrankConstants";
import {
  currencyFormat,
  handleLocalize,
  numberFormatWithoutCurrency,
} from "../../utils/helper";
import CustomizedSteppers from "../../UiComponent/OrderStatusStepper";
import StripeCheckout from "../MyAnnounces/StripeCheckout";
import { addDoc, collection } from "firebase/firestore";
import { firestoreDB } from "../../utils/notificationListner";
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}
function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ padding: "0px 16px" }}>{children}</Box>}
    </div>
  );
}
function DrawerAnnounceDetail(props: any) {
  const { classes, ann_id, onClose } = props;

  // eslint-disable-next-line
  const [otp, setOtp] = React.useState("");
  const selector = useSelector((state: RootState) => state.mainApp);
  const [selectedImage, setSelectedImage] = useState("");
  const param = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [state, setState] = React.useReducer(
    (state: any, newState: any) => ({ ...state, ...newState }),
    {
      showPickupOtpScreen: false,
      openStripeForm: false,
      loadingLoader: true,
      openConfirmDialog: false,
      ratingsCount: 1,
      itemDetailsDialog: false,
      doNotShowPromo: true,
      is_hover: false,
    }
  );

  const [hover, setHover] = useState(-1);

  const stripePromise = loadStripe(
    "pk_live_51PHLwERrtK56w4VJcMQLW2zbn7LTZPNZnBLUmFdMIakX5v5HKsPRllmYUMmWJXvmPVJaptcEN8uxmQdzDNVJYFUC0050uiD5gE"
    // "pk_test_51PHLwERrtK56w4VJovEUBRsfDb0K90Mo3tt7QrypEedKpj9HuTszcu8bnI8SnXsmA7EWSwZ87LorkcfAHi7zXz4l00kogJUBL5"
  );

  const handleGetProdInfo = async (job_id: any) => {
    try {
      const resp = await apiServices.getFromApi(
        `c2c-shipments/${job_id ?? param?.id}`,
        ""
      );
      const data = resp.data;

      if (!resp.data) {
        setState({ doNotShow: true, loadingLoader: false });
        return;
      }
      let total_amt = 0;
      if (data?.handling) {
        total_amt =
          data?.order_amount_detail?.sub_total > 0
            ? Number(data?.order_amount_detail?.sub_total ?? 0)
            : Number(data?.agree_ship_price ?? data?.ship_price ?? 0) +
              Number(
                (Number(data?.agree_ship_price ?? data?.ship_price ?? 0) /
                  100) *
                  Number(data?.handling?.handling_charges_percent)
              ) +
              Number(data?.service_charges ?? 0);
      } else {
        total_amt =
          data?.order_amount_detail?.sub_total > 0
            ? Number(data?.order_amount_detail?.sub_total ?? 0) +
              Number(data?.service_charges ?? 0)
            : Number(data?.agree_ship_price ?? data?.ship_price ?? 0) +
              Number(data?.service_charges ?? 0);
      }

      const steps = [
        {
          status: "Mise en ligne",
          created_at: data?.order_statuses?.[0]?.created_at
            ? data?.order_statuses?.[0]?.created_at
            : "",
          active: data?.order_statuses?.[0]?.created_at ? true : false,
        },
        {
          status: "Acceptée",
          created_at: data?.order_statuses?.[1]?.created_at
            ? data?.order_statuses?.[1]?.created_at
            : "",
          active: data?.order_statuses?.[1]?.created_at ? true : false,
        },
        {
          status: "Payée",
          created_at:
            data?.payment_status === "Paid" ? "2025-03-24T11:39:40.242Z" : "",
          active: data?.payment_status === "Paid" ? true : false,
        },

        {
          status: "Expédiée",
          created_at: data?.order_statuses?.[2]?.created_at
            ? data?.order_statuses?.[2]?.created_at
            : "",
          active: data?.order_statuses?.[2]?.created_at ? true : false,
        },
        {
          status: "Livrée",

          created_at: data?.order_statuses?.[3]?.created_at
            ? data?.order_statuses?.[3]?.created_at
            : "",
          active: data?.order_statuses?.[3]?.created_at ? true : false,
        },
        {
          status: "Laisser un commentaire",

          created_at: data?.feedback ? data?.feedback?.created_at : "",

          active: data?.feedback ? true : false,
        },
        {
          status: "Merci",

          created_at: data?.feedback ? "" : "",

          active: data?.feedback ? true : false,
        },
      ];
      setSelectedImage(
        data?.shipment_items?.[0]?.prod_images?.[0] ?? noImageFile
      );
      const totalImages = data?.shipment_items?.reduce(
        (acc: any, item: any) => acc + (item?.prod_images?.length || 0),
        0
      );
      setState({
        totalImages,
        job_details: data,
        total_amt,
        loadingLoader: false,
        steps,
      });
      //
      if (resp.data?.acc_id) {
        const response = await apiServices.getFromApi(
          `c2c/get-user-details/${resp.data?.acc_id}`,
          ""
        );

        let avg_rating_ = response.data?.ratings2?.reduce((a: any, b: any) => {
          return a + b.rating;
        }, 0);
        let avg_rating = isNaN(avg_rating_ / response?.data?.ratings2?.length)
          ? 0
          : avg_rating_ / response?.data?.ratings2?.length;

        setState({ acceptor_detail: response?.data, avg_rating });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  const onInputChange = (e: any) => {
    try {
      const { value, name } = e.target;
      if (value?.[0] === " ") {
        return;
      }

      setState({
        [name]: value,
      });
    } catch (error) {}
  };
  const handleDeleteShipment = async () => {
    try {
      let resp = await apiServices.postFromApi(
        `c2c-shipments/delete/${state?.job_details?.id}`,
        {},
        ""
      );
      if (resp?.status === 200 || resp?.status === 201) {
        setState({ openConfirmDialog: false });
        Toast.showSuccess("Annonce supprimée avec succès");
        onClose();
        window.location.reload();
      }
    } catch (error) {}
  };

  useEffect(() => {
    if (
      state.job_details?.ship_status_level === 2 &&
      state.job_details?.payment_status !== "Paid"
    ) {
      initPayment();
    }
    // eslint-disable-next-line
  }, [JSON.stringify(state.job_details)]);

  const handleSendOtpAfterPayment = async () => {
    try {
      handleGetProdInfo(ann_id);
      let new_msg: any = {
        message: `The payment was confirmed successfully!`,
        message_status: "sent",
        order_id: `${state.job_details?.id ?? ""}`,
        is_negotiate: true,
        payment_msg: true,
        order_details: null,
        sender_id: `${selector?.user?.id}`,
        receiver_id: `${state.job_details?.acc_id}`,
        created_at: new Date().toISOString(),
        ship_id: `${state.job_details?.id}`,
      };
      await addDoc(collection(firestoreDB, `chat_negotiations`), new_msg);
      Toast.showSuccess("Paiement validé");

      setState({
        openStripeForm: false,
      });
    } catch (error) {
      console.log(error);
    }
  };
  const initPayment = async () => {
    try {
      let total_amt = 0;
      if (state.job_details?.handling) {
        total_amt =
          state.job_details?.order_amount_detail?.sub_total > 0
            ? Number(state.job_details?.order_amount_detail?.sub_total ?? 0)
            : Number(
                state.job_details?.agree_ship_price ??
                  state.job_details?.ship_price ??
                  0
              ) +
              Number(
                (Number(
                  state.job_details?.agree_ship_price ??
                    state.job_details?.ship_price ??
                    0
                ) /
                  100) *
                  Number(state.job_details?.handling?.handling_charges_percent)
              ) +
              Number(state.job_details?.service_charges ?? 0);
      } else {
        total_amt =
          state.job_details?.order_amount_detail?.sub_total > 0
            ? Number(state.job_details?.order_amount_detail?.sub_total ?? 0) +
              Number(state.job_details?.service_charges ?? 0)
            : Number(
                state.job_details?.agree_ship_price ??
                  state.job_details?.ship_price ??
                  0
              ) + Number(state.job_details?.service_charges ?? 0);
      }

      const response = await apiServices.postFromApi(
        "stripe/payment-sheet-with-card",
        {
          ship_id: Number(state?.job_details?.id),
          amount: Number(total_amt.toFixed(2)),
        },
        ""
      );

      let decryptData = JSON.parse(decrypt(response?.pi_key));
      if (typeof decryptData === "string") {
        decryptData = JSON.parse(decryptData);
      }
      const { paymentIntent } = decryptData ?? {};

      const options = {
        theme: "stripe",

        clientSecret: paymentIntent,
        appearance: {
          theme: "stripe",
          variables: {
            fontFamily: '"Raleway-Variable", sans-serif',
          },
          rules: {
            ".Label": {
              fontFamily: '"Raleway-Variable", sans-serif',
              fontSize: "14px", // Adjust the size as needed
              color: "#000000", // Change the color if needed
            },
          },
        },
      };

      setState({ options, show_stripe: true });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    handleGetProdInfo(ann_id);
    // eslint-disable-next-line
  }, []);

  const handleAddFeedback = async () => {
    try {
      let obj = {
        order_id: Number(state.job_details?.id),
        rating_to_id: `${state.job_details?.acc_id}`,
        rating_from_id: `${state.job_details?.user_details?.id}`,
        rating: state?.ratingsCount ?? 1,
        feedback: state?.feedback,
      };

      // return;
      let resp = await apiServices.postFromApi(
        "c2c-feedbacks",
        { data: [obj] },
        ""
      );

      if (resp?.status === 200 || resp?.status === 201) {
        handleGetProdInfo(state.job_details?.id);
        Toast.showSuccess("Notes attribuées au transporteur avec succès");
        setState({
          feedbackDialog: false,
        });
      }
    } catch (error) {}
  };

  const transSizes = (item: any) => {
    const deliveryType = FrankConstants.packageSize(selector.lang)?.find(
      (a: any) => a.size === item?.cat_name
    );
    return deliveryType?.weight_fr;
  };
  const transSizesName = (item: any) => {
    const deliveryType = FrankConstants.packageSize(selector.lang)?.find(
      (a: any) => a.size === item?.cat_name
    );
    return deliveryType?.size_trans;
  };
  const handleValidatePromo = async () => {
    try {
      const data = state.job_details;
      let total_amt = 0,
        platform_fee = Number(data?.service_charges ?? 0);
      if (data?.handling) {
        total_amt =
          data?.order_amount_detail?.sub_total > 0
            ? Number(data?.order_amount_detail?.sub_total ?? 0)
            : Number(data?.agree_ship_price ?? data?.ship_price ?? 0) +
              Number(
                (Number(data?.agree_ship_price ?? data?.ship_price ?? 0) /
                  100) *
                  Number(data?.handling?.handling_charges_percent)
              ) +
              Number(data?.service_charges ?? 0);
      } else {
        total_amt =
          data?.order_amount_detail?.sub_total > 0
            ? Number(data?.order_amount_detail?.sub_total ?? 0) +
              Number(data?.service_charges ?? 0)
            : Number(data?.agree_ship_price ?? data?.ship_price ?? 0) +
              Number(data?.service_charges ?? 0);
      }
      const promo_resp = await apiServices.postFromApi(
        "c2c-promo-codes/validate-announce",
        {
          order_id: Number(state.job_details?.id),
          channel: "web",
          actual_order_amount: Number(
            data?.agree_ship_price ?? data?.ship_price ?? 0
          ),
          total_shipment_amt: 0,
          platform_fee: platform_fee,
          total_amount: total_amt,
          promo_code: `${state.promo_code_text ?? ""}`?.toLowerCase(),
          promo_code_type: "announcement",
        },
        ""
      );
      console.log("promo_resp", {
        order_id: Number(state.job_details?.id),
        channel: "web",
        actual_order_amount: Number(
          data?.agree_ship_price ?? data?.ship_price ?? 0
        ),
        total_shipment_amt: 0,
        platform_fee: platform_fee,
        total_amount: total_amt,
        promo_code: `${state.promo_code_text ?? ""}`?.toLowerCase(),
        promo_code_type: "announcement",
      });

      if (promo_resp.status === 200) {
        const resp = await apiServices.postFromApi(
          "stripe/regenerate-payment-intent-announce",
          {
            ship_id: Number(state.job_details?.id),
          },
          ""
        );

        if (resp?.status === 200 || resp?.status === 201) {
          handleGetProdInfo(ann_id);
          setState({
            doNotShowPromo: false,
            openStripeForm: false,
            promo_resp,
          });
          setState({ openStripeForm: true });
          Toast.showSuccess("Code promotionnel appliqué 🥳");
        }
      } else {
        Toast.Error(
          selector.lang === "en"
            ? "Invalid promo code"
            : "Code promotionnel invalide"
        );
      }
    } catch (error) {
      console.log(error);
    }
  };
  const { job_details } = state;

  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }
  const [showMore, setShowMore] = useState(false);

  return (
    <>
      <div>
        {state?.loadingLoader ? (
          <Loader loading={state?.loadingLoader} />
        ) : (
          <div style={{ background: "#FFFF", padding: 24 }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              {job_details?.shipment_items?.length > 1 ? (
                <div>
                  <h3
                    style={{
                      color: "#080626",
                      fontFamily: "montserrat-Bold",
                      fontSize: 18,
                      marginLeft: 1,
                      display: "-webkit-box",
                      WebkitLineClamp: 1, // Ensures the text is limited to one line
                      lineClamp: 1, // Fallback for browsers that support it
                      WebkitBoxOrient: "vertical",
                      maxWidth: "100%",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {job_details?.shipment_items?.length ?? 1} articles :
                    <span
                      style={{
                        color: "#78778A",
                        fontFamily: "montserrat-Regular",
                        fontSize: 12,
                        marginLeft: 1,
                      }}
                    >
                      {" "}
                      {job_details?.shipment_items
                        ?.map((item: any) => item.item_name_fr)
                        .join(", ")}
                    </span>
                  </h3>
                </div>
              ) : (
                <h3
                  style={{
                    color: "#080626",
                    fontFamily: "montserrat-Bold",
                    fontSize: 18,
                  }}
                >
                  {" "}
                  {handleLocalize({
                    en: job_details?.shipment_items?.[0]?.item_name_en?.en,
                    fr: job_details?.shipment_items?.[0]?.item_name_fr?.en,
                  }) ??
                    job_details?.shipment_items?.[0]?.prod_name ??
                    ""}
                </h3>
              )}

              <IconButton onClick={onClose}>
                <Close />
              </IconButton>
            </Box>

            <div style={{ display: "flex", gap: 24, padding: "10px 0px" }}>
              <div
                style={{
                  borderRadius: "8px",
                  padding: "4px 12px",
                  fontFamily: "montserrat-Bold",
                  fontSize: 16,
                  background: getStatusColors[job_details?.ship_status]?.bg,
                  color: getStatusColors[job_details?.ship_status]?.txt,
                  height: "max-content",
                }}
              >
                {job_details?.ship_status === "Accepted" &&
                job_details?.payment_status === "Paid"
                  ? "Payée"
                  : handleLocalize(
                      status_translations[job_details?.ship_status]
                    )}
              </div>
              <div>
                {" "}
                <p
                  style={{
                    margin: 0,
                    color: defaultLabelColors?.main_orange_new,
                    fontSize: 24,
                    fontFamily: "montserrat-Bold",
                  }}
                >{`${
                  currencyFormat(
                    job_details?.agree_ship_price
                      ? job_details?.agree_ship_price
                      : job_details?.ship_price
                  ) ?? ""
                } €`}</p>
              </div>
            </div>

            <div
              id="scroller-image"
              style={{
                display: "flex",
                overflowX: "auto", // Enables horizontal scrolling
                gap: "10px", // Space between images
              }}
              className={classes?.scrollableAreaa}
            >
              {job_details?.shipment_items?.map((item: any, itemIndex: any) =>
                item?.prod_images?.map((image: any, index: any) => (
                  <div
                    key={`${itemIndex}-${index}`}
                    style={{
                      flex: "0 0 auto", // Important for horizontal scroll
                      padding: "10px 0px",
                      width:
                        state?.totalImages === 1
                          ? "100%"
                          : state?.totalImages === 2
                          ? "49%"
                          : state?.totalImages === 3
                          ? "32%"
                          : "210px",
                    }}
                  >
                    <img
                      src={image}
                      alt="image-not-found"
                      onError={(e) => {
                        e.currentTarget.onerror = null; // Prevent infinite loop
                        e.currentTarget.src = noImageTwo; // Replace with your fallback image variable
                      }}
                      style={{
                        width: "100%",
                        height: state?.totalImages <= 1 ? "285px" : "210px",
                        objectFit: "cover",
                        borderRadius: "16px",
                      }}
                    />
                  </div>
                ))
              )}
            </div>

            <div className="display-flex" style={{ margin: "20px 0px" }}>
              {job_details?.ship_status_level === 2 &&
              job_details?.payment_status !== "Paid" ? (
                <>
                  {!job_details?.user_payment_init ? (
                    <div
                      style={{
                        background: state?.show_stripe
                          ? defaultLabelColors?.main_orange_new
                          : "lightgrey",
                        borderRadius: "12px",
                        color: state?.show_stripe ? "#fff" : "#fff",
                        fontSize: "16px",
                        fontFamily: "montserrat-Bold",
                        padding: "12px 20px",
                        textAlign: "center",
                        cursor: "pointer",
                        width: "235px",
                      }}
                      onClick={() => {
                        if (state?.show_stripe) {
                          setState({ openStripeForm: true });
                        } else {
                          return;
                        }
                      }}
                    >
                      {"Procéder au paiement"}
                    </div>
                  ) : (
                    <div
                      style={{
                        background: "lightgrey",
                        borderRadius: "16px",
                        color: state?.show_stripe ? "#000" : "#fff",
                        fontSize: "16px",
                        fontFamily: "montserrat-Bold",
                        padding: "12px 20px",
                        textAlign: "center",
                        cursor: "pointer",
                        width: "231px",
                      }}
                    >
                      {"le paiement est en cours 🗳️"}
                    </div>
                  )}
                </>
              ) : null}

              {job_details?.ship_pickup_otp &&
              job_details?.ship_status === "Accepted" ? (
                <>
                  <div
                    style={{
                      paddingTop: 10,
                      flexDirection: "column",
                      gap: 15,
                    }}
                    className="display-flex"
                  >
                    <p
                      style={{
                        fontFamily: "montserrat-Bold",
                        fontSize: "18px",
                        color: "#080626",
                        margin: 0,
                        paddingTop: "5px",
                      }}
                    >
                      Code à transmettre au transporteur
                    </p>
                    <OTPInput
                      inputStyle={{
                        fontFamily: "montserrat-Bold",
                        fontSize: "18px",
                        fontWeight: "900",
                        color: "#000",
                        border: "1px solid #C0C0C0",
                        background: "#FFFF",
                        borderRadius: "10px",
                        padding: "16px",
                      }}
                      inputType="number"
                      value={job_details?.ship_pickup_otp}
                      onChange={(otpValue) => {
                        setOtp(otpValue);
                      }}
                      numInputs={4}
                      renderSeparator={<span style={{ padding: "5px" }}></span>}
                      renderInput={(props) => <input {...props} readOnly />}
                    />
                  </div>
                </>
              ) : null}

              {job_details?.ship_deliver_otp &&
              job_details?.ship_status === "Picked" ? (
                <>
                  <div
                    className="display-flex"
                    style={{ flexDirection: "column", gap: 10 }}
                  >
                    <div
                      style={{
                        paddingTop: 10,
                        flexDirection: "column",
                        gap: 15,
                      }}
                      className="display-flex"
                    >
                      <p
                        style={{
                          fontFamily: "montserrat-Bold",
                          fontSize: "12px",
                          color: "#E0E0E0",
                          margin: 0,
                          paddingTop: "5px",
                        }}
                      >
                        Code à transmettre au transporteur
                      </p>
                      <OTPInput
                        inputStyle={{
                          fontFamily: "montserrat-Bold",
                          fontSize: "12px",
                          fontWeight: "900",
                          color: "#E0E0E0",
                          border: "1px solid #E0E0E0",
                          background: "#FFFF",
                          borderRadius: "10px",
                          padding: "10px",
                        }}
                        inputType="number"
                        value={job_details?.ship_pickup_otp}
                        onChange={(otpValue) => {
                          setOtp(otpValue);
                        }}
                        numInputs={4}
                        renderSeparator={
                          <span style={{ padding: "5px" }}></span>
                        }
                        renderInput={(props) => <input {...props} readOnly />}
                      />
                    </div>
                    <div
                      style={{
                        flexDirection: "column",
                        gap: 15,
                      }}
                      className="display-flex"
                    >
                      <p
                        style={{
                          fontFamily: "montserrat-Bold",
                          fontSize: "18px",
                          color: "#080626",
                          margin: 0,
                          paddingTop: "5px",
                        }}
                      >
                        Destinataire: Code à transmettre au transporteur
                      </p>
                      <OTPInput
                        inputStyle={{
                          fontFamily: "montserrat-Bold",
                          fontSize: "18px",
                          fontWeight: "900",
                          color: "#000",
                          border: "1px solid #C0C0C0",
                          background: "#FFFF",
                          borderRadius: "10px",
                          padding: "16px",
                        }}
                        inputType="number"
                        value={job_details?.ship_deliver_otp}
                        onChange={(otpValue) => {
                          setOtp(otpValue);
                        }}
                        numInputs={4}
                        renderSeparator={
                          <span style={{ padding: "5px" }}></span>
                        }
                        renderInput={(props) => <input {...props} readOnly />}
                      />
                    </div>
                  </div>
                </>
              ) : null}

              {job_details?.ship_status === "Deliver" ? (
                job_details?.feedback ? null : (
                  <>
                    <div
                      style={{
                        background: defaultLabelColors?.main_orange_new,
                        borderRadius: "12px",
                        color: "#FFF",
                        fontSize: "16px",

                        fontFamily: "montserrat-Bold",
                        padding: "12px 16px",
                        textAlign: "center",
                        cursor: "pointer",
                        width: "251px",
                      }}
                      onClick={() => {
                        setState({ feedbackDialog: true });
                      }}
                    >
                      Laisser un commentaire
                    </div>
                  </>
                )
              ) : null}
            </div>
            <div style={{ borderBottom: "1px solid #E0E0E0" }}>
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
                sx={{ width: "100%" }}
                TabIndicatorProps={{
                  style: {
                    backgroundColor: defaultLabelColors?.main_orange_new,
                    color: defaultLabelColors?.main_orange_new,
                  },
                }}
              >
                <Tab
                  label="Détails"
                  {...a11yProps(0)}
                  sx={{
                    fontFamily: "montserrat-SemiBold",
                    textTransform: "none", // Disable uppercase
                    color: "#000000",
                    paddingLeft: "0px !important",
                    textAlign: "left !important",
                    minWidth: "0px !important",

                    "&.Mui-selected": {
                      color: defaultLabelColors?.main_orange_new,
                    },
                  }}
                />
                <Tab
                  label="Suivi"
                  {...a11yProps(1)}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "flex-start",
                    minWidth: "0px !important",
                    fontFamily: "montserrat-SemiBold",
                    padding: "12px 10px 12px 1px",
                    textTransform: "none", // Disable uppercase
                    color: "#000000",
                    "&.Mui-selected": {
                      color: defaultLabelColors?.main_orange_new,
                    },
                  }}
                />
              </Tabs>
            </div>

            <CustomTabPanel value={value} index={0}>
              <div>
                {job_details?.ship_status_level > 1 ? (
                  <>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 10,
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <p
                          style={{
                            color: "#080626",
                            fontFamily: "montserrat-Regular",
                            fontSize: 14,
                          }}
                        >
                          Détail du transporteur
                        </p>{" "}
                        <p
                          style={{
                            color: "#78778A",
                            fontFamily: "montserrat-Regular",
                            fontSize: 12,
                          }}
                        >
                          {`Membre depuis ${moment(
                            state?.acceptor_detail?.created_at
                          ).format("YYYY")}`}
                        </p>
                      </div>
                      <div style={{ display: "flex", gap: 15 }}>
                        <div style={{ position: "relative" }}>
                          <Avatar
                            alt="Remy Sharp"
                            src={
                              state?.acceptor_detail?.profile_pic ??
                              no_profile_image
                            }
                            // "https://t4.ftcdn.net/jpg/02/79/66/93/360_F_279669366_Lk12QalYQKMczLEa4ySjhaLtx1M2u7e6.jpg"
                            style={{ width: 60, height: 60 }}
                          />
                          {state?.acceptor_detail?.idenfy_verification ===
                            true &&
                          state?.acceptor_detail?.idenfy_verification_status ===
                            "APPROVED" ? (
                            <div
                              style={{
                                position: "absolute",
                                bottom: "0%",
                                right: 0,
                              }}
                            >
                              <VerifyIcon />
                            </div>
                          ) : null}
                        </div>

                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 10,
                          }}
                        >
                          <p
                            style={{
                              color: "#080626",
                              fontFamily: "montserrat-Bold",
                              fontSize: 18,
                              margin: 0,
                            }}
                          >
                            {`${state?.acceptor_detail?.first_name ?? ""} ${
                              state?.acceptor_detail?.surname ?? ""
                            }`}
                          </p>
                          <div style={{ display: "flex" }}>
                            <p
                              style={{
                                color: "#080626",
                                fontFamily: "montserrat-Bold",
                                fontSize: 18,
                                margin: 0,
                              }}
                            >
                              {currencyFormat(state?.avg_rating?.toFixed())}{" "}
                              &nbsp;
                            </p>
                            <span style={{ display: "flex" }}>
                              <svg
                                width="20"
                                height="19"
                                viewBox="0 0 20 19"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M9.60404 1.91371C9.64056 1.83993 9.69697 1.77782 9.76692 1.7344C9.83686 1.69098 9.91755 1.66797 9.99987 1.66797C10.0822 1.66797 10.1629 1.69098 10.2328 1.7344C10.3028 1.77782 10.3592 1.83993 10.3957 1.91371L12.3207 5.81288C12.4475 6.06952 12.6347 6.29155 12.8662 6.45992C13.0977 6.6283 13.3666 6.73797 13.6499 6.77955L17.9549 7.40955C18.0364 7.42137 18.1131 7.45577 18.1761 7.50888C18.2391 7.56199 18.2861 7.63167 18.3116 7.71005C18.337 7.78843 18.3401 7.87239 18.3204 7.95241C18.3006 8.03243 18.2589 8.10534 18.1999 8.16288L15.0865 11.1945C14.8812 11.3946 14.7276 11.6416 14.6389 11.9142C14.5502 12.1869 14.5291 12.477 14.5774 12.7595L15.3124 17.0429C15.3268 17.1244 15.318 17.2083 15.287 17.2851C15.2559 17.3619 15.204 17.4284 15.137 17.477C15.07 17.5257 14.9907 17.5545 14.9081 17.5603C14.8255 17.566 14.743 17.5485 14.6699 17.5095L10.8215 15.4862C10.568 15.3531 10.2859 15.2835 9.99946 15.2835C9.71306 15.2835 9.43094 15.3531 9.17737 15.4862L5.32987 17.5095C5.25681 17.5482 5.17437 17.5656 5.09191 17.5598C5.00946 17.5539 4.9303 17.525 4.86345 17.4764C4.7966 17.4278 4.74473 17.3614 4.71375 17.2847C4.68277 17.2081 4.67392 17.1243 4.68821 17.0429L5.42237 12.7604C5.47087 12.4777 5.44986 12.1874 5.36115 11.9146C5.27245 11.6418 5.11871 11.3947 4.91321 11.1945L1.79987 8.16371C1.74037 8.10624 1.6982 8.03321 1.67817 7.95294C1.65815 7.87267 1.66107 7.78839 1.6866 7.70971C1.71214 7.63102 1.75926 7.56108 1.8226 7.50787C1.88594 7.45465 1.96296 7.4203 2.04487 7.40871L6.34904 6.77955C6.63259 6.7383 6.90186 6.62876 7.13369 6.46037C7.36552 6.29198 7.55296 6.06977 7.67987 5.81288L9.60404 1.91371Z"
                                  fill="black"
                                  stroke="black"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                            </span>
                          </div>
                        </div>
                      </div>
                      {location?.pathname === "/chat" ? null : (
                        <div
                          style={{
                            background: "#ffff",
                            borderRadius: "12px",
                            color: "#080626",
                            fontSize: "16px",
                            fontFamily: "montserrat-Bold",
                            padding: "12px 20px",
                            textAlign: "center",
                            cursor: "pointer",
                            width: "205px",
                            border: "1px solid #BCBBC4",
                          }}
                          onClick={() => {
                            navigate(`/chat/0/${job_details?.id}`);
                          }}
                        >
                          {"Accéder à la messagerie"}
                        </div>
                      )}

                      <Divider
                        color="#E9E8EB"
                        style={{ marginTop: 20 }}
                        sx={{
                          "&::before, &::after": {
                            color: "#E9E8EB",
                          },
                        }}
                      ></Divider>
                    </div>
                  </>
                ) : null}
                {job_details?.ship_status_level === 1 && (
                  <Divider style={{ marginTop: 20 }}></Divider>
                )}
                <div
                  className="card-details"
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    marginTop: 20,
                    gap: 15,
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-around",
                    }}
                  >
                    <div
                      style={{
                        width: "36px",
                        height: "36px",
                        borderRadius: "50%",
                        background: "#FFFFFF",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <HomeIcon height={30} color="#3026F1" />
                    </div>

                    {/* Dashed Line */}
                    <div
                      style={{
                        width: "2px",
                        height: "60px",
                        borderLeft: "2px dashed #BCBBC4",
                        margin: "auto",
                      }}
                    />
                    <div
                      style={{
                        width: "36px",
                        height: "36px",
                        borderRadius: "50%",
                        background: "#FFFFFF",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <PointerIcon height={30} color="#F15A24" />
                    </div>
                  </div>
                  <div
                    id="address-div"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      flexDirection: "column",
                      width: "100%",
                    }}
                  >
                    <div
                      id="yess"
                      style={{
                        display: "flex",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 4,
                        }}
                      >
                        <div
                          style={{
                            color: "#0000000",
                            fontSize: 14,
                            fontFamily: "montserrat-Regular",
                            margin: "2px 0px",
                          }}
                        >
                          Adresse de ramassage
                        </div>
                        <div
                          style={{
                            color: "#0000000",
                            fontSize: 16,
                            fontFamily: "montserrat-SemiBold",
                          }}
                        >
                          {`${job_details?.pickup?.address ?? ""} `}
                          <div
                            style={{
                              fontSize: 12,
                              fontFamily: "montserrat-Regular",
                              color: "#00000",
                              margin: "2px 0px",
                            }}
                          >
                            {`${job_details?.pickup?.additional_info ?? ""} `}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 4,
                      }}
                    >
                      <div
                        style={{
                          color: "#0000000",
                          fontSize: 14,
                          fontFamily: "montserrat-Regular",
                        }}
                      >
                        Adresse de livraison
                      </div>
                      <div
                        style={{
                          color: "#0000000",
                          fontSize: 16,
                          fontFamily: "montserrat-SemiBold",
                        }}
                      >
                        {`${job_details?.dropoff?.address ?? ""} `}
                      </div>
                      <div
                        style={{
                          fontSize: 12,
                          fontFamily: "montserrat-Regular",
                          color: "#00000",
                        }}
                      >
                        {`${job_details?.dropoff?.additional_info} `}
                      </div>
                    </div>
                  </div>
                </div>
                <Divider
                  color="#E9E8EB"
                  style={{ marginTop: 20 }}
                  sx={{
                    "&::before, &::after": {
                      color: "#E9E8EB",
                    },
                  }}
                ></Divider>
                <div>
                  <div>
                    <h3
                      style={{
                        fontSize: 18,
                        fontFamily: "montserrat-Bold",
                      }}
                    >
                      Destinataire
                    </h3>

                    <p
                      style={{
                        fontSize: 16,
                        fontFamily: "montserrat-SemiBold",
                        margin: 0,
                        color: "#4B4A61",
                      }}
                    >
                      {job_details?.recipient_name ?? ""}
                    </p>
                    <p
                      style={{
                        fontSize: 16,
                        fontFamily: "montserrat-SemiBold",
                        margin: 0,
                        marginTop: 2,

                        color: "#4B4A61",
                      }}
                    >
                      {job_details?.recipient_phone_code}{" "}
                      {job_details?.recipient_phone}
                    </p>
                  </div>
                </div>
                <Divider
                  color="#E9E8EB"
                  style={{ marginTop: 20, marginBottom: 20 }}
                  sx={{
                    "&::before, &::after": {
                      color: "#E9E8EB",
                    },
                  }}
                ></Divider>
                {job_details?.shipment_items?.length > 1 ? (
                  <>
                    {job_details?.shipment_items?.map((i: any) => (
                      <Accordion
                        elevation={0}
                        sx={{
                          border: "none",
                          background: "#FFFF",
                          margin: 0,
                          "&::before": { display: "none" },
                        }}
                      >
                        <AccordionSummary
                          style={{ border: "none" }}
                          expandIcon={<ExpandedIcon />} // Dynamic icon change
                          sx={{
                            "&.Mui-expanded h3": {
                              color: defaultLabelColors?.main_orange_new,
                            },
                            padding: 0,
                          }}
                        >
                          <h3
                            style={{
                              fontFamily: "montserrat-Bold",
                              color: "#080626",
                              fontSize: 18,
                              margin: 0,
                            }}
                          >
                            {handleLocalize({
                              en: i?.item_name_en,
                              fr: i?.item_name_fr,
                            })}
                          </h3>
                        </AccordionSummary>
                        <AccordionDetails>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: 8,
                            }}
                          >
                            <p
                              style={{
                                fontSize: 14,
                                fontFamily: "montserrat-Regular",
                                color: "#4B4A61",
                              }}
                            >
                              Produits & dimension
                            </p>

                            <p
                              style={{
                                fontSize: 16,
                                fontFamily: "montserrat-Bold",
                                margin: 0,
                                color: "#080626",
                              }}
                            >
                              {transSizesName(i)} ·&nbsp;
                              <span
                                style={{
                                  fontSize: 16,
                                  fontFamily: "montserrat-Regular",
                                  margin: 0,
                                  color: "#626175",
                                }}
                              >
                                {transSizes(i)}
                              </span>
                            </p>
                            <p
                              style={{
                                fontSize: 16,
                                fontFamily: "montserrat-Bold",
                                margin: 0,
                                color: "#080626",
                              }}
                            >
                              Quantité :&nbsp;
                              <span
                                style={{
                                  fontSize: 16,
                                  fontFamily: "montserrat-Regular",
                                  margin: 0,
                                  color: "#626175",
                                }}
                              >
                                {`x ${i?.prod_quantity}`}
                              </span>
                            </p>
                            <p
                              style={{
                                fontSize: 16,
                                fontFamily: "montserrat-Bold",
                                margin: 0,
                                color: "#080626",
                              }}
                            >
                              Dimensions :&nbsp;
                              <span
                                style={{
                                  fontSize: 16,
                                  fontFamily: "montserrat-Regular",
                                  margin: 0,
                                  color: "#626175",
                                }}
                              >
                                {i?.prod_length ?? 0} x{""}
                                {i?.prod_height ?? 0} x{""}
                                {i?.prod_width ?? 0}
                              </span>
                            </p>
                            <p
                              style={{
                                fontSize: 16,
                                fontFamily: "montserrat-Bold",
                                margin: 0,
                                color: "#080626",
                              }}
                            >
                              Fragile :&nbsp;
                              <span
                                style={{
                                  fontSize: 16,
                                  fontFamily: "montserrat-Regular",
                                  margin: 0,
                                  color: "#626175",
                                }}
                              >
                                {i?.prod_is_fragile ? "Oui" : "Non"}
                              </span>
                            </p>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: 8,
                              }}
                            >
                              <p
                                style={{
                                  fontSize: 14,
                                  fontFamily: "montserrat-Regular",
                                  color: "#4B4A61",
                                }}
                              >
                                Informations complémentaires
                              </p>

                              <p
                                style={{
                                  fontSize: 14,
                                  fontFamily: "montserrat-Regular",
                                  color: "#000000",
                                  margin: 0,
                                }}
                              >
                                {i?.prod_desc
                                  ? showMore
                                    ? i?.prod_desc
                                    : i?.prod_desc?.slice(0, 150) +
                                      (i?.prod_desc.length > 150 ? "..." : "")
                                  : "No complémentaires"}
                              </p>

                              {i?.prod_desc && i?.prod_desc.length > 150 && (
                                <button
                                  onClick={() => setShowMore(!showMore)}
                                  style={{
                                    fontSize: 14,
                                    fontFamily: "montserrat-Medium",
                                    color: "#0000000",
                                    background: "none",
                                    border: "none",
                                    cursor: "pointer",
                                    padding: 0,
                                    textAlign: "center",
                                    textDecoration: "underline",
                                  }}
                                >
                                  {showMore ? "Voir moins" : "Voir plus"}
                                </button>
                              )}
                            </div>
                          </div>
                        </AccordionDetails>
                      </Accordion>
                    ))}
                  </>
                ) : (
                  <div
                    style={{ display: "flex", flexDirection: "column", gap: 8 }}
                  >
                    <p
                      style={{
                        fontSize: 14,
                        fontFamily: "montserrat-Regular",
                        color: "#4B4A61",
                      }}
                    >
                      Produits & dimension
                    </p>

                    <p
                      style={{
                        fontSize: 16,
                        fontFamily: "montserrat-Bold",
                        margin: 0,
                        color: "#080626",
                      }}
                    >
                      {transSizesName(job_details?.shipment_items?.[0])} ·&nbsp;
                      <span
                        style={{
                          fontSize: 16,
                          fontFamily: "montserrat-Regular",
                          margin: 0,
                          color: "#626175",
                        }}
                      >
                        {transSizes(job_details?.shipment_items?.[0])}
                      </span>
                    </p>
                    <p
                      style={{
                        fontSize: 16,
                        fontFamily: "montserrat-Bold",
                        margin: 0,
                        color: "#080626",
                      }}
                    >
                      Quantité :&nbsp;
                      <span
                        style={{
                          fontSize: 16,
                          fontFamily: "montserrat-Regular",
                          margin: 0,
                          color: "#626175",
                        }}
                      >
                        {`x ${job_details?.shipment_items?.[0]?.prod_quantity}`}
                      </span>
                    </p>
                    <p
                      style={{
                        fontSize: 16,
                        fontFamily: "montserrat-Bold",
                        margin: 0,
                        color: "#080626",
                      }}
                    >
                      Dimensions :&nbsp;
                      <span
                        style={{
                          fontSize: 16,
                          fontFamily: "montserrat-Regular",
                          margin: 0,
                          color: "#626175",
                        }}
                      >
                        {job_details?.shipment_items?.[0]?.prod_length ?? 0} x
                        {""}
                        {job_details?.shipment_items?.[0]?.prod_height ?? 0} x
                        {""}
                        {job_details?.shipment_items?.[0]?.prod_width ?? 0}
                      </span>
                    </p>
                    <p
                      style={{
                        fontSize: 16,
                        fontFamily: "montserrat-Bold",
                        margin: 0,
                        color: "#080626",
                      }}
                    >
                      Fragile :&nbsp;
                      <span
                        style={{
                          fontSize: 16,
                          fontFamily: "montserrat-Regular",
                          margin: 0,
                          color: "#626175",
                        }}
                      >
                        {job_details?.shipment_items?.[0]?.prod_is_fragile
                          ? "Oui"
                          : "Non"}
                      </span>
                    </p>
                  </div>
                )}

                <Divider
                  color="#E9E8EB"
                  style={{ marginTop: 20 }}
                  sx={{
                    "&::before, &::after": {
                      color: "#E9E8EB",
                    },
                  }}
                ></Divider>
                {job_details?.shipment_items?.length === 1 && (
                  <>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 8,
                      }}
                    >
                      <p
                        style={{
                          fontSize: 14,
                          fontFamily: "montserrat-Regular",
                          color: "#4B4A61",
                        }}
                      >
                        Informations complémentaires
                      </p>

                      <p
                        style={{
                          fontSize: 14,
                          fontFamily: "montserrat-Regular",
                          color: "#000000",
                          margin: 0,
                        }}
                      >
                        {job_details?.shipment_items[0]?.prod_desc
                          ? showMore
                            ? job_details?.shipment_items[0]?.prod_desc
                            : job_details?.shipment_items[0]?.prod_desc?.slice(
                                0,
                                150
                              ) +
                              (job_details?.shipment_items[0]?.prod_desc
                                .length > 150
                                ? "..."
                                : "")
                          : "No complémentaires"}
                      </p>

                      {job_details?.shipment_items[0]?.prod_desc &&
                        job_details?.shipment_items[0]?.prod_desc.length >
                          150 && (
                          <button
                            onClick={() => setShowMore(!showMore)}
                            style={{
                              fontSize: 14,
                              fontFamily: "montserrat-Medium",
                              color: "#0000000",
                              background: "none",
                              border: "none",
                              cursor: "pointer",
                              padding: 0,
                              textAlign: "center",
                              textDecoration: "underline",
                            }}
                          >
                            {showMore ? "Voir moins" : "Voir plus"}
                          </button>
                        )}
                    </div>
                    <Divider
                      color="#E9E8EB"
                      style={{ marginTop: 20 }}
                      sx={{
                        "&::before, &::after": {
                          color: "#E9E8EB",
                        },
                      }}
                    ></Divider>
                  </>
                )}

                <div
                  style={{ display: "flex", flexDirection: "column", gap: 8 }}
                >
                  <p
                    style={{
                      fontSize: 14,
                      fontFamily: "montserrat-Regular",
                      color: "#4B4A61",
                      margin: 0,
                      marginTop: 5,
                    }}
                  >
                    Votre envoi
                  </p>
                  <div
                    style={{
                      fontSize: 14,
                      fontFamily: "montserrat-Regular",
                      color: "#000000",
                      margin: 0,
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <p style={{ margin: 0 }}>Tarif proposé</p>{" "}
                    <p style={{ margin: 0 }}>
                      {" "}
                      {job_details?.promo ? (
                        <span style={{ marginRight: "10px", color: "red" }}>
                          {" "}
                          <s>
                            {job_details?.agree_ship_price
                              ? job_details?.agree_ship_price
                              : job_details?.ship_price}
                          </s>
                        </span>
                      ) : null}
                      {job_details?.promo
                        ? currencyFormat(
                            Number(
                              (job_details?.agree_ship_price ||
                                job_details?.ship_price) -
                                (job_details?.promo?.discount_amount || 0)
                            )
                          )
                        : currencyFormat(
                            Number(
                              job_details?.agree_ship_price ??
                                job_details?.ship_price ??
                                0
                            )
                          )}{" "}
                      €
                    </p>
                  </div>
                  <div
                    style={{
                      fontSize: 14,
                      fontFamily: "montserrat-Regular",
                      color: "#000000",
                      margin: 0,
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <p style={{ margin: 0 }}> {strings?.service_charges}</p>{" "}
                    <p style={{ margin: 0 }}>
                      {job_details?.promo?.is_platform_charges ? (
                        <span style={{ marginRight: "10px", color: "red" }}>
                          {" "}
                          <s>{job_details?.service_charges}</s>
                        </span>
                      ) : null}
                      {job_details?.promo?.is_platform_charges
                        ? "0.00"
                        : currencyFormat(
                            Number(job_details?.service_charges ?? 1.99)
                          )}{" "}
                      €
                    </p>
                  </div>
                  <div
                    style={{
                      fontSize: 18,
                      fontFamily: "montserrat-Bold",
                      color: defaultLabelColors?.main_orange_new,
                      margin: 0,
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <p style={{ margin: 0 }}>Total </p>{" "}
                    <p style={{ margin: 0 }}>
                      {" "}
                      {job_details?.promo
                        ? currencyFormat(
                            Number(
                              Number(
                                job_details?.promo?.actual_order_amount -
                                  job_details?.promo?.discount_amount
                              )
                            ) +
                              Number(
                                job_details?.promo?.is_platform_charges
                                  ? 0
                                  : job_details?.service_charges
                              )
                          )
                        : currencyFormat(
                            Number(
                              Number(
                                job_details?.agree_ship_price ??
                                  job_details?.ship_price ??
                                  0
                              ) +
                                Number(
                                  job_details?.promo?.is_platform_charges
                                    ? 0
                                    : job_details?.service_charges
                                )
                            )
                          )}{" "}
                      €
                    </p>
                  </div>
                </div>

                {job_details?.ship_status_level === 1 ||
                job_details?.ship_status === "Placed" ? (
                  <>
                    <Divider
                      color="#E9E8EB"
                      style={{ marginTop: 20 }}
                      sx={{
                        "&::before, &::after": {
                          color: "#E9E8EB",
                        },
                      }}
                    ></Divider>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 16,
                      }}
                    >
                      <div></div>
                      <div>
                        <p
                          style={{
                            margin: 0,
                            textAlign: "right",
                            color: "#F00",
                            fontSize: 16,
                            fontFamily: "montserrat-SemiBold",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            setState({ openConfirmDialog: true });
                          }}
                        >
                          Supprimer l’annonce
                        </p>
                      </div>
                    </div>
                  </>
                ) : null}
              </div>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
              <CustomizedSteppers order_array={state?.steps} />
            </CustomTabPanel>
          </div>
        )}

        <DraggableDialog
          maxWidth={"md"}
          Width={600}
          open={state?.openStripeForm}
          handleClose={() => {
            setState({ openStripeForm: false });
          }}
          dialog_title={strings.payments}
          classes={classes}
          dialogBody={
            <DialogContent>
              <div>
                <div
                  style={{
                    border: "1px solid #E9E8EB",
                    borderRadius: "18px",
                    padding: "12px 14px",
                  }}
                >
                  {!job_details?.promo && state?.doNotShowPromo ? (
                    <div>
                      <p
                        style={{
                          fontFamily: "montserrat-Bold",
                          color: "#080626",
                          fontSize: "20px",
                          margin: "0px 0px 6px 0px",
                        }}
                      >
                        Code promo{" "}
                      </p>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          width: "100%",
                        }}
                      >
                        <div style={{ width: "65%" }}>
                          <div
                            style={{
                              height: 56,
                              width: "100%",
                              background: "#F4F3F6",
                              display: "flex",
                              alignItems: "center",
                              borderRadius: 12,
                              paddingLeft: 10,
                            }}
                          >
                            <input
                              style={{
                                border: "none",
                                outline: "none",
                                fontSize: "16px",
                                width: "100%",
                                textTransform: "uppercase",
                                background: "#F4F3F6",
                              }}
                              value={state.promo_code_text}
                              onChange={(e) =>
                                setState({
                                  promo_code_text: e.target.value,
                                })
                              }
                              placeholder={"Saisissez le code "}
                            />
                          </div>
                        </div>
                        <button
                          style={{
                            width: "30%",
                            marginLeft: "5%",
                            padding: "12px 24px",
                            backgroundColor: state.promo_code_text
                              ? color_theme.main_orange
                              : color_theme.disabled,
                            borderRadius: 12,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: state.promo_code_text
                              ? "pointer"
                              : "not-allowed",
                            border: "none",
                            outline: "none",
                            height: "56px",
                          }}
                          onClick={handleValidatePromo}
                          disabled={!state.promo_code_text} // Disable button when promo code is empty
                        >
                          <span
                            style={{
                              fontSize: 14,
                              fontFamily: "montserrat-SemiBold",
                              lineHeight: "18px",
                              color: state.promo_code_text
                                ? color_theme.white
                                : "#a4a4a4",
                            }}
                          >
                            Valider
                          </span>
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div>
                      <p
                        style={{
                          margin: "7px",
                          fontFamily: "montserrat-Bold",
                          color: "#080626",
                          fontSize: "20px",
                          marginLeft: "0px",
                          marginTop: "0px",
                          marginBottom: "0px",
                        }}
                      >
                        Code promo{" "}
                      </p>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          width: "100%",
                        }}
                      >
                        <div style={{ width: "65%" }}>
                          <div
                            style={{
                              height: 56,
                              width: "100%",
                              background: "#F4F3F6",
                              display: "flex",
                              alignItems: "center",
                              borderRadius: 12,
                              paddingLeft: 10,
                            }}
                          >
                            <input
                              style={{
                                border: "none",
                                outline: "none",
                                fontSize: "16px",
                                width: "100%",
                                textTransform: "uppercase",
                                background: "#F4F3F6",
                              }}
                              readOnly
                              value={job_details?.promo?.promo_code}
                              placeholder={"Saisissez le code "}
                            />
                          </div>
                        </div>
                        <div
                          style={{
                            width: "30%",
                            marginLeft: "5%",
                            padding: "12px 24px",
                            borderRadius: 12,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            border: "none",
                            outline: "none",
                            height: "56px",
                          }}
                        >
                          <span
                            style={{
                              fontSize: 16,
                              fontFamily: "montserrat-Bold",
                              lineHeight: "18px",
                              color: defaultLabelColors.main_orange_new,
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              gap: "10px",
                            }}
                          >
                            Appliqué{" "}
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M2 9C2.79565 9 3.55871 9.31607 4.12132 9.87868C4.68393 10.4413 5 11.2044 5 12C5 12.7956 4.68393 13.5587 4.12132 14.1213C3.55871 14.6839 2.79565 15 2 15V17C2 17.5304 2.21071 18.0391 2.58579 18.4142C2.96086 18.7893 3.46957 19 4 19H20C20.5304 19 21.0391 18.7893 21.4142 18.4142C21.7893 18.0391 22 17.5304 22 17V15C21.2044 15 20.4413 14.6839 19.8787 14.1213C19.3161 13.5587 19 12.7956 19 12C19 11.2044 19.3161 10.4413 19.8787 9.87868C20.4413 9.31607 21.2044 9 22 9V7C22 6.46957 21.7893 5.96086 21.4142 5.58579C21.0391 5.21071 20.5304 5 20 5H4C3.46957 5 2.96086 5.21071 2.58579 5.58579C2.21071 5.96086 2 6.46957 2 7V9Z"
                                stroke="#EF6A31"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M9 12L11 14L15 10"
                                stroke="#EF6A31"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          </span>
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                {job_details?.promo ? (
                  <div
                    style={{
                      padding: "15px 10px",
                      display: "flex",
                      flexDirection: "column",
                      position: "relative",
                      rowGap: 14,
                      borderRadius: 5,
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                      }}
                    >
                      <p
                        style={{
                          fontFamily: "montserrat-Regular",
                          fontSize: 14,
                          margin: 0,
                          color: "#4B4A61",
                        }}
                      >
                        {strings?.delivery_cost}
                      </p>
                      <p
                        style={{
                          fontFamily: "montserrat-SemiBold",
                          fontSize: 16,
                          margin: 0,
                          color: "#4B4A61",
                        }}
                      >
                        {numberFormatWithoutCurrency(
                          Number(
                            job_details?.agree_ship_price ??
                              job_details?.ship_price ??
                              0
                          )
                        )}
                        €
                      </p>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                      }}
                    >
                      <p
                        style={{
                          fontFamily: "montserrat-Regular",
                          fontSize: 14,
                          margin: 0,
                          color: "#4B4A61",
                        }}
                      >
                        {strings?.service_charges}
                      </p>
                      <p
                        style={{
                          fontFamily: "montserrat-SemiBold",
                          fontSize: 16,
                          color: "#4B4A61",
                          margin: 0,
                        }}
                      >
                        {job_details?.promo?.is_platform_charges ? (
                          <>
                            {" "}
                            <span
                              style={{
                                marginRight: "10px",
                                fontSize: "12px",
                                opacity: "0.7",
                                color: "red",
                              }}
                            >
                              {" "}
                              <s>
                                {currencyFormat(
                                  job_details?.service_charges ?? 1.99
                                )}
                              </s>
                            </span>{" "}
                            ---{" "}
                          </>
                        ) : (
                          numberFormatWithoutCurrency(
                            Number(job_details?.service_charges ?? 1.99)
                          )
                        )}
                      </p>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                      }}
                    >
                      <p
                        style={{
                          fontFamily: "montserrat-SemiBold",
                          fontSize: 14,
                          margin: 0,
                          color: "#4B4A61",
                        }}
                      >
                        Sous total
                      </p>
                      <p
                        style={{
                          fontFamily: "montserrat-SemiBold",
                          fontSize: 16,
                          color: "#4B4A61",
                          margin: 0,
                        }}
                      >
                        {job_details?.promo?.is_platform_charges
                          ? currencyFormat(
                              0 +
                                (job_details?.agree_ship_price
                                  ? job_details?.agree_ship_price
                                  : job_details?.ship_price)
                            )
                          : currencyFormat(
                              (job_details?.service_charges ?? 1.99) +
                                (job_details?.agree_ship_price
                                  ? job_details?.agree_ship_price
                                  : job_details?.ship_price)
                            )}
                        €
                      </p>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                      }}
                    >
                      <p
                        style={{
                          fontFamily: "montserrat-Regular",
                          fontSize: 14,
                          margin: 0,
                          color: "#4B4A61",
                        }}
                      >
                        Code promo:{" "}
                        <span
                          style={{
                            fontFamily: "montserrat-Medium",
                            fontSize: "14px",
                            textTransform: "uppercase",
                            color: "#000",
                          }}
                        >
                          {" "}
                          {job_details?.promo?.promo_code}{" "}
                        </span>
                      </p>
                      <p
                        style={{
                          fontFamily: "montserrat-SemiBold",
                          fontSize: 16,
                          color: "#4B4A61",
                          margin: 0,
                        }}
                      >
                        -{currencyFormat(job_details?.promo?.discount_amount)}€
                      </p>
                    </div>

                    <div style={{ height: "1px", background: "#E0E0E0" }}></div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                      }}
                    >
                      <p
                        style={{
                          fontFamily: "montserrat-SemiBold",
                          fontSize: 14,
                          margin: 0,
                          color: "#4B4A61",
                        }}
                      >
                        {strings?.total}
                      </p>
                      <p
                        style={{
                          fontFamily: "montserrat-SemiBold",
                          fontSize: 16,
                          margin: 0,
                          color: color_theme.main_orange,
                        }}
                      >
                        {job_details?.promo
                          ? currencyFormat(
                              Number(
                                Number(
                                  job_details?.promo?.actual_order_amount -
                                    job_details?.promo?.discount_amount
                                )
                              ) +
                                Number(
                                  job_details?.promo?.is_platform_charges
                                    ? 0
                                    : job_details?.service_charges
                                )
                            )
                          : currencyFormat(
                              Number(
                                Number(
                                  job_details?.agree_ship_price ??
                                    job_details?.ship_price ??
                                    0
                                ) +
                                  Number(
                                    job_details?.promo?.is_platform_charges
                                      ? 0
                                      : job_details?.service_charges
                                  )
                              )
                            )}{" "}
                        €
                      </p>
                    </div>
                  </div>
                ) : (
                  <div
                    style={{
                      padding: "15px 10px",
                      display: "flex",
                      flexDirection: "column",
                      position: "relative",
                      rowGap: 14,
                      borderRadius: 5,
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                      }}
                    >
                      <p
                        style={{
                          fontFamily: "montserrat-Regular",
                          fontSize: 14,
                          margin: 0,
                          color: "#4B4A61",
                        }}
                      >
                        {strings?.delivery_cost}
                      </p>
                      <p
                        style={{
                          fontFamily: "montserrat-SemiBold",
                          fontSize: 16,
                          margin: 0,
                          color: "#4B4A61",
                        }}
                      >
                        {" "}
                        {job_details?.promo ? (
                          <span style={{ marginRight: "10px", color: "red" }}>
                            {" "}
                            <s>
                              {currencyFormat(
                                job_details?.agree_ship_price
                                  ? job_details?.agree_ship_price
                                  : job_details?.ship_price
                              )}
                            </s>
                          </span>
                        ) : null}
                        {job_details?.promo
                          ? currencyFormat(
                              Number(
                                (job_details?.agree_ship_price ||
                                  job_details?.ship_price) -
                                  (job_details?.promo?.discount_amount || 0)
                              )
                            )
                          : currencyFormat(
                              Number(
                                job_details?.agree_ship_price ??
                                  job_details?.ship_price ??
                                  0
                              )
                            )}
                        €
                      </p>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                      }}
                    >
                      <p
                        style={{
                          fontFamily: "montserrat-Regular",
                          fontSize: 14,
                          margin: 0,
                          color: "#4B4A61",
                        }}
                      >
                        {strings?.service_charges}
                      </p>
                      <p
                        style={{
                          fontFamily: "montserrat-SemiBold",
                          fontSize: 16,
                          color: "#4B4A61",
                          margin: 0,
                        }}
                      >
                        {job_details?.promo?.is_platform_charges ? (
                          <span style={{ marginRight: "10px", color: "red" }}>
                            {" "}
                            <s>{job_details?.service_charges}</s>
                          </span>
                        ) : null}
                        {job_details?.promo?.is_platform_charges
                          ? "0.00"
                          : currencyFormat(
                              Number(job_details?.service_charges ?? 1.99)
                            )}
                        €
                      </p>
                    </div>

                    <div style={{ height: "1px", background: "#E0E0E0" }}></div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                      }}
                    >
                      <p
                        style={{
                          fontFamily: "montserrat-SemiBold",
                          fontSize: 14,
                          margin: 0,
                          color: "#4B4A61",
                        }}
                      >
                        {strings?.total}
                      </p>
                      <p
                        style={{
                          fontFamily: "montserrat-SemiBold",
                          fontSize: 16,
                          margin: 0,
                          color: color_theme.main_orange,
                        }}
                      >
                        {job_details?.promo
                          ? currencyFormat(
                              Number(
                                Number(
                                  job_details?.promo?.actual_order_amount -
                                    job_details?.promo?.discount_amount
                                )
                              ) +
                                Number(
                                  job_details?.promo?.is_platform_charges
                                    ? 0
                                    : job_details?.service_charges
                                )
                            )
                          : currencyFormat(
                              Number(
                                Number(
                                  job_details?.agree_ship_price ??
                                    job_details?.ship_price ??
                                    0
                                ) +
                                  Number(
                                    job_details?.promo?.is_platform_charges
                                      ? 0
                                      : job_details?.service_charges
                                  )
                              )
                            )}{" "}
                        €
                      </p>
                    </div>
                  </div>
                )}

                <div style={{ marginTop: "5px" }}>
                  <Elements stripe={stripePromise} options={state.options}>
                    <StripeCheckout handleOtpSend={handleSendOtpAfterPayment} />
                  </Elements>
                </div>
              </div>
            </DialogContent>
          }
        />
        <DraggableDialog
          maxWidth={"sm"}
          open={state?.openConfirmDialog}
          handleClose={() => {
            setState({ openConfirmDialog: false });
          }}
          dialog_title={"Confirmation"}
          classes={classes}
          dialogBody={
            <DialogContent style={{}} dividers>
              <div>
                <p
                  style={{
                    fontFamily: "Raleway-Variable",
                    fontSize: "26px",
                    fontWeight: "600",
                  }}
                >
                  Voulez-vous supprimer votre annonce ?
                </p>
              </div>
            </DialogContent>
          }
          dialogFooter={
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "flex-end",
                gap: 10,
                padding: 10,
              }}
            >
              <CustomButton
                value={"Oui"}
                style={{
                  fontSize: "16px",
                  fontWeight: "500",
                  color: "#fff",
                  fontFamily: "Raleway-Variable",
                  background: "#ee6931",
                  border: "none",
                  borderRadius: "12px",
                  padding: "10px 40px 10px 40px",
                  marginTop: "10px",
                }}
                onClick={handleDeleteShipment}
              />
              <CustomButton
                value={"Non"}
                style={{
                  fontSize: "16px",
                  fontWeight: "500",
                  color: "#ee6931",
                  border: "1px solid #ee6931",
                  fontFamily: "Raleway-Variable",
                  background: "#fff",
                  borderRadius: "12px",
                  padding: "10px 40px 10px 40px",
                  marginTop: "10px",
                }}
                onClick={() => {
                  setState({ openConfirmDialog: false });
                }}
              />
            </div>
          }
        />
        {/* idher feedback ha */}
        <DraggableDialog
          maxWidth={"md"}
          Width={660}
          open={state?.feedbackDialog}
          handleClose={() => {
            setState({
              feedbackDialog: false,
            });
          }}
          dialog_title={"Laisser un commentaire"}
          dialogBody={
            <DialogContent style={{}}>
              <>
                <div
                  style={{
                    padding: 10,
                    borderBottom: "1px solid #E9E8EB",
                    gap: 10,
                  }}
                >
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <div
                      style={{
                        // width: "20%",
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        gap: 20,
                      }}
                    >
                      <div style={{ position: "relative" }}>
                        <Avatar
                          alt="Remy Sharp"
                          src={job_details?.acc_picture ?? no_profile_image}
                          // "https://t4.ftcdn.net/jpg/02/79/66/93/360_F_279669366_Lk12QalYQKMczLEa4ySjhaLtx1M2u7e6.jpg"
                          style={{ width: 60, height: 60 }}
                        />
                        <div
                          style={{
                            position: "absolute",
                            bottom: "0%",
                            right: 0,
                          }}
                        >
                          <VerifyIcon />
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          gap: 10,
                          flexDirection: "column",
                        }}
                      >
                        <div
                          style={{
                            fontFamily: "montserrat-Bold",
                            color: "#080626",

                            fontSize: "18px",
                            fontWeight: 600,
                          }}
                        >
                          {job_details?.acc_name ?? "Customer Name"}
                        </div>
                        <div style={{ display: "flex" }}>
                          <p
                            style={{
                              color: "#080626",
                              fontFamily: "montserrat-Bold",
                              fontSize: 22,
                              margin: 0,
                            }}
                          >
                            {currencyFormat(state?.avg_rating?.toFixed(1))}{" "}
                            &nbsp;
                          </p>
                          <span style={{ display: "flex" }}>
                            <svg
                              width="20"
                              height="19"
                              viewBox="0 0 20 19"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M9.60404 1.91371C9.64056 1.83993 9.69697 1.77782 9.76692 1.7344C9.83686 1.69098 9.91755 1.66797 9.99987 1.66797C10.0822 1.66797 10.1629 1.69098 10.2328 1.7344C10.3028 1.77782 10.3592 1.83993 10.3957 1.91371L12.3207 5.81288C12.4475 6.06952 12.6347 6.29155 12.8662 6.45992C13.0977 6.6283 13.3666 6.73797 13.6499 6.77955L17.9549 7.40955C18.0364 7.42137 18.1131 7.45577 18.1761 7.50888C18.2391 7.56199 18.2861 7.63167 18.3116 7.71005C18.337 7.78843 18.3401 7.87239 18.3204 7.95241C18.3006 8.03243 18.2589 8.10534 18.1999 8.16288L15.0865 11.1945C14.8812 11.3946 14.7276 11.6416 14.6389 11.9142C14.5502 12.1869 14.5291 12.477 14.5774 12.7595L15.3124 17.0429C15.3268 17.1244 15.318 17.2083 15.287 17.2851C15.2559 17.3619 15.204 17.4284 15.137 17.477C15.07 17.5257 14.9907 17.5545 14.9081 17.5603C14.8255 17.566 14.743 17.5485 14.6699 17.5095L10.8215 15.4862C10.568 15.3531 10.2859 15.2835 9.99946 15.2835C9.71306 15.2835 9.43094 15.3531 9.17737 15.4862L5.32987 17.5095C5.25681 17.5482 5.17437 17.5656 5.09191 17.5598C5.00946 17.5539 4.9303 17.525 4.86345 17.4764C4.7966 17.4278 4.74473 17.3614 4.71375 17.2847C4.68277 17.2081 4.67392 17.1243 4.68821 17.0429L5.42237 12.7604C5.47087 12.4777 5.44986 12.1874 5.36115 11.9146C5.27245 11.6418 5.11871 11.3947 4.91321 11.1945L1.79987 8.16371C1.74037 8.10624 1.6982 8.03321 1.67817 7.95294C1.65815 7.87267 1.66107 7.78839 1.6866 7.70971C1.71214 7.63102 1.75926 7.56108 1.8226 7.50787C1.88594 7.45465 1.96296 7.4203 2.04487 7.40871L6.34904 6.77955C6.63259 6.7383 6.90186 6.62876 7.13369 6.46037C7.36552 6.29198 7.55296 6.06977 7.67987 5.81288L9.60404 1.91371Z"
                                fill="black"
                                stroke="black"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          </span>
                        </div>
                      </div>
                    </div>

                    <div style={{ display: "flex", justifyContent: "center" }}>
                      <Rating
                        name="three-icons"
                        value={state?.ratingsCount}
                        max={5}
                        precision={1}
                        onChange={(event, newValue) => {
                          setState({ ratingsCount: newValue });
                        }}
                        onChangeActive={(event, newHover) => {
                          setHover(newHover);
                        }}
                        IconContainerComponent={({
                          value: index,
                          ...props
                        }) => {
                          if (hover !== -1) {
                            // When hovering
                            if (index < hover) {
                              return (
                                <span {...props}>
                                  <StarIcon />
                                </span>
                              );
                            } else if (index === hover) {
                              // The hovered star
                              return (
                                <span {...props}>
                                  <HoverStar />
                                </span>
                              );
                            } else {
                              return (
                                <span {...props}>
                                  <StarIconGray />
                                </span>
                              );
                            }
                          } else {
                            if (state?.ratingsCount >= index) {
                              return (
                                <span {...props}>
                                  <StarIcon />
                                </span>
                              );
                            } else {
                              return (
                                <span {...props}>
                                  <StarIconGray />
                                </span>
                              );
                            }
                          }
                        }}
                        sx={{ fontSize: 40, gap: "5px" }}
                      />
                    </div>
                  </div>
                </div>
                <div style={{ padding: 0 }}>
                  <p
                    style={{
                      marginBottom: 1,
                      fontFamily: "montserrat-Bold",
                      color: "#080626",
                      fontSize: "16px",
                    }}
                  >
                    Écrivez votre commentaire
                  </p>
                  <div
                    id="yessor"
                    style={{
                      display: "flex",
                      gap: 30,
                      flexDirection: "column",
                    }}
                  >
                    <TextField
                      placeholder="Exemple : Parfait ! Rapide et efficace"
                      variant="outlined"
                      fullWidth
                      type="text"
                      value={state.feedback ?? ""}
                      name="feedback"
                      onChange={onInputChange}
                      maxRows={3}
                      minRows={3}
                      multiline
                      InputProps={{
                        sx: {
                          backgroundColor: "#F4F3F6",
                          fontFamily: "montserrat-Regular",
                          border: "none",

                          "& fieldset": {
                            border: "none",
                          },
                        },
                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "16px", // Optional: rounded corners
                        },
                      }}
                    />
                    <CustomButton
                      style={{
                        fontSize: "16px",
                        fontWeight: "500",
                        color: "#fff",
                        fontFamily: "Raleway-Variable",
                        background: state?.feedback ? "#ee6931" : "lightgrey",
                        border: "none",
                        borderRadius: "12px",
                        padding: "10px 40px 10px 40px",
                        width: "100%",
                      }}
                      disable={state?.feedback ? false : true}
                      onClick={handleAddFeedback}
                      value={"Envoyer"}
                    />
                  </div>
                </div>
              </>
            </DialogContent>
          }
        />
        <DraggableDialog
          maxWidth={"md"}
          open={state?.itemDetailsDialog}
          handleClose={() => {
            setState({ itemDetailsDialog: false });
          }}
          dialog_title={""}
          classes={classes}
          dialogBody={
            <DialogContent style={{}} dividers>
              <div>
                <Card
                  elevation={0}
                  sx={{
                    borderRadius: "32px",
                    overflow: "hidden",
                    border: "1px solid #E0E0E0",
                  }}
                >
                  <Box
                    position="relative"
                    sx={{ borderRadius: "32px 32px 0px 0px" }}
                  >
                    <div style={{ height: "380px" }} className="display-flex">
                      <CardMedia
                        component="img"
                        image={
                          selectedImage ?? "https://via.placeholder.com/300x200"
                        }
                        alt="Product Image"
                        sx={{
                          objectFit: "contain",
                          width: "98%",
                          height: "360px",
                          borderRadius: "32px 32px 0px 0px",
                        }}
                      />
                    </div>
                  </Box>

                  <CardContent>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginBottom: "30px",
                      }}
                    >
                      <div style={{ flex: 1 }}>
                        <Typography
                          variant="h6"
                          color="#3B3A3A"
                          sx={{
                            fontFamily: "Raleway-Bold",
                          }}
                        >
                          {handleLocalize({
                            en: state?.itemDetails?.item_name_en,
                            fr: state?.itemDetails?.item_name_fr,
                          }) ??
                            state?.itemDetails?.prod_name ??
                            ""}
                          <span> </span>
                        </Typography>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        gap: 5,
                      }}
                    >
                      {state?.itemDetails?.prod_images?.map((item: any) => {
                        return (
                          <div
                            className="display-flex"
                            style={{
                              height: "116px",
                              width: "116px",
                              cursor: "pointer",
                              borderRadius: "12px",
                              border: `2px solid ${
                                selectedImage === item
                                  ? defaultLabelColors.main_orange
                                  : "grey"
                              } `,
                            }}
                            onClick={() => {
                              setSelectedImage(item);
                            }}
                          >
                            <img
                              src={item}
                              alt="prod-img"
                              style={{
                                objectFit: "contain",
                                height: "110px",
                              }}
                            />
                          </div>
                        );
                      })}
                    </div>
                  </CardContent>
                </Card>
              </div>
            </DialogContent>
          }
        />
      </div>
    </>
  );
}

export default DrawerAnnounceDetail;
